<template>
    <div>
        <header-section
                title="Claims Dashboard"
                set-position="fixed"
                :create-button="true"
                :set-border="true">
        </header-section>
        <div id="app" class="o-content ie p-your-claims">
            <claims-dashboard-icons></claims-dashboard-icons>
            <claim-table ref="claims" show-delete @select="loadClaimAndView" @delete="deleteClaim"></claim-table>
        </div>
        <modal name="confirm_delete" :no-default-button="true">
            <div>
                <h1>Are you sure you want to delete this claim?</h1>
                <p>Once you delete this claim you can not get it back, are you sure?</p>
                <button class="a-button" @click="performDelete" style="background: red;">
                    Delete
                </button>
                <button class="a-button" @click="dismissClose">
                    Close
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import ClaimsDashboardIcons from 'pages/claims-dashboard/components/Icons';
    import ClaimTable from 'pages/claims-dashboard/components/Table';
    import HeaderSection from 'components/Header.vue';
    import {claimTypes} from 'store/modules/claim';
    import Modal from "../../components/modal/Modal";

    export default {
        components: {
            Modal,
            ClaimsDashboardIcons,
            ClaimTable,
            HeaderSection
        },
        computed: mapGetters('menu', [
            'isMenuOpen',
        ]),
        data() {
            return {
                claimToDelete: null
            };
        },
        methods: {
            ...mapActions('menu', [
                'updateMenu',
                'collapseMenu',
                'updateSubMenu',
            ]),
            ...mapActions('claim', [
                'load',
                'delete',
            ]),
            ...mapActions('modal', ['toggle']),
            loadClaimAndView(claim) {
                this.openSubMenu(claim.type);
                this.load({claim, router: this.$router});
            },
            deleteClaim(claim) {
                this.claimToDelete = claim;
                this.toggle('confirm_delete')
            },
            openSubMenu(type) {
                this.updateSubMenu(claimTypes[type]);
            },
            subMenu() {
                if (this.isMenuOpen) {
                    this.updateMenu(false);
                }
            },
            performDelete() {
                this.delete({claim: this.claimToDelete})
                    .then(() => {
                        this.dismissClose();
                        this.$refs.claims.search()
                    });
            },
            dismissClose() {
                this.claimToDelete = null;
                this.toggle('confirm_delete');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClaimsDashboard.vue?5345c102